import { action } from 'src/store/actions';

/* Customer Mail Addresses */
export const FETCH_CUSTOMER_MAIL_ADDRESSES = 'FETCH_CUSTOMER_MAIL_ADDRESSES';
export const REQUEST_CUSTOMER_MAIL_ADDRESSES = 'REQUEST_CUSTOMER_MAIL_ADDRESSES';
export const SUCCESS_CUSTOMER_MAIL_ADDRESSES = 'SUCCESS_CUSTOMER_MAIL_ADDRESSES';
export const FAILURE_CUSTOMER_MAIL_ADDRESSES = 'FAILURE_CUSTOMER_MAIL_ADDRESSES';

export const fetchCustomerMailAddresses = () => action(FETCH_CUSTOMER_MAIL_ADDRESSES);
export const requestCustomerMailAddresses = () => action(REQUEST_CUSTOMER_MAIL_ADDRESSES);
export const requestCustomerMailAddressesSuccess = (response: any) =>
    action(SUCCESS_CUSTOMER_MAIL_ADDRESSES, { response });
export const requestCustomerMailAddressesFailure = (error: any) => action(FAILURE_CUSTOMER_MAIL_ADDRESSES, { error });

/* Customer Phone Numbers */
export const FETCH_CUSTOMER_PHONE_NUMBERS = 'FETCH_CUSTOMER_PHONE_NUMBERS';
export const REQUEST_CUSTOMER_PHONE_NUMBERS = 'REQUEST_CUSTOMER_PHONE_NUMBERS';
export const SUCCESS_CUSTOMER_PHONE_NUMBERS = 'SUCCESS_CUSTOMER_PHONE_NUMBERS';
export const FAILURE_CUSTOMER_PHONE_NUMBERS = 'FAILURE_CUSTOMER_PHONE_NUMBERS';

export const fetchCustomerPhoneNumbers = () => action(FETCH_CUSTOMER_PHONE_NUMBERS);
export const requestCustomerPhoneNumbers = () => action(REQUEST_CUSTOMER_PHONE_NUMBERS);
export const requestCustomerPhoneNumbersSuccess = (response: any) =>
    action(SUCCESS_CUSTOMER_PHONE_NUMBERS, { response });
export const requestCustomerPhoneNumbersFailure = (error: any) => action(FAILURE_CUSTOMER_PHONE_NUMBERS, { error });

/* Customer Data */
export const FETCH_CUSTOMER_DATA = 'FETCH_CUSTOMER_DATA';
export const REQUEST_CUSTOMER_DATA = 'REQUEST_CUSTOMER_DATA';
export const SUCCESS_CUSTOMER_DATA = 'SUCCESS_CUSTOMER_DATA';
export const FAILURE_CUSTOMER_DATA = 'FAILURE_CUSTOMER_DATA';

export const fetchCustomerData = () => action(FETCH_CUSTOMER_DATA);
export const requestCustomerData = () => action(REQUEST_CUSTOMER_DATA);
export const requestCustomerDataSuccess = (response: any) => action(SUCCESS_CUSTOMER_DATA, { response });
export const requestCustomerDataFailure = (error: any) => action(FAILURE_CUSTOMER_DATA, { error });

/* Customer Feedback */
export const FETCH_CUSTOMER_FEEDBACK = 'FETCH_CUSTOMER_FEEDBACK';
export const REQUEST_CUSTOMER_FEEDBACK = 'REQUEST_CUSTOMER_FEEDBACK';
export const SUCCESS_CUSTOMER_FEEDBACK = 'SUCCESS_CUSTOMER_FEEDBACK';
export const FAILURE_CUSTOMER_FEEDBACK = 'FAILURE_CUSTOMER_FEEDBACK';

export const fetchCustomerFeedback = () => action(FETCH_CUSTOMER_FEEDBACK);
export const requestCustomerFeedback = () => action(REQUEST_CUSTOMER_FEEDBACK);
export const requestCustomerFeedbackSuccess = (response: any) => action(SUCCESS_CUSTOMER_FEEDBACK, { response });
export const requestCustomerFeedbackFailure = (error: any) => action(FAILURE_CUSTOMER_FEEDBACK, { error });
